/* [ASB] Dawn 15.4.0 file with custom edits — search '[ASB' below.
   Edits: [ASB nav] HeaderMenu keeps the mega-menu height cap in step with the header while open
   (pairs with the max-height rule in sections/header.liquid). Built by: Claude (2026-10-27, menu-compact). */
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.onScroll = this.onScroll.bind(this); /* [ASB nav] */
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    /* [ASB nav] START — replaces Dawn's one-time --header-bottom-position-desktop measurement. */
    // Keep the mega menu height cap matched to where the header is while the panel is open.
    if (this.mainDetailsToggle.open) {
      this.setHeaderBottom();
      window.addEventListener('scroll', this.onScroll, { passive: true });
    } else {
      window.removeEventListener('scroll', this.onScroll);
    }
  }

  onScroll() {
    if (this.scrollFrame) return;
    this.scrollFrame = requestAnimationFrame(() => {
      this.scrollFrame = null;
      if (this.mainDetailsToggle.open) this.setHeaderBottom();
    });
  }

  setHeaderBottom() {
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
  /* [ASB nav] END */
}

customElements.define('header-menu', HeaderMenu);
